/** The soft tint behind a member's avatar, from their `avatarHue` (same look as `tint()` in the builder and launcher). */
export function avatarTint(hue: number, strength = 1.35): string {
  return `hsl(${hue} 75% 60% / calc(var(--tint-alpha) * ${strength}))`;
}
